<template>
  <div :class="classes()">
    <Container>
      <Widget>
        <Headline :heading="1" size="m" isViewHeadline>{{ $t('contact.title') }}</Headline>
        <Headline size="xs" color="primaryBlue" :staticClass="`${el}__headline`">
          {{ $t('contact.type.text') }}
        </Headline>
        <div :class="`${el}__contact`">
          <div>
            <strong>{{ $t('contact.type.post') }}</strong>
            <Copy>
              {{ $t('contact.type.post.details.description') }}
            </Copy>
            <Copy :staticClass="`${el}__address`">{{ $t('contact.type.post.details') }}</Copy>
          </div>
          <div>
            <strong>{{ $t('contact.type.email') }}</strong>
            <Copy>
              <a :href="`mailto:${CONTACT_EMAIL}`">{{ CONTACT_EMAIL }}</a>
            </Copy>
          </div>
        </div>

        <Headline size="xs" color="primaryBlue" :staticClass="`${el}__headline`">
          {{ $t('contact.feedback') }}
        </Headline>
        <Copy>
          <span v-html="$t('contact.feedback.details', { link: LAMAPOLL_URL })" />
        </Copy>
        <Headline size="xs" color="primaryBlue" :staticClass="`${el}__headline`">
          {{ $t('contact.privacy') }}
        </Headline>
        <Copy>
          <span v-html="$t('contact.privacy.details', { link: ROUTE_PRIVACY })" />
        </Copy>
        <Headline size="xs" color="primaryBlue" :staticClass="`${el}__headline`">
          {{ $t('contact.press') }}
        </Headline>
        <Copy>
          <span v-html="$t('contact.press.text', { link: PRESS_URL })" />
        </Copy>
      </Widget>
    </Container>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Container from '@/objects/Container/Container';
import Copy from '@/objects/Copy';
import Widget from '@/objects/Widget';

import { LAMAPOLL_URL, PRESS_URL, CONTACT_EMAIL } from '@/constants/generics';
import { ROUTE_PRIVACY } from '@/constants/routes';

export default {
  name: 'Contact',
  title: 'Kontakt',
  props: {},
  components: { Container, Headline, Copy, Widget },
  data() {
    return {
      LAMAPOLL_URL,
      CONTACT_EMAIL,
      PRESS_URL,
      ROUTE_PRIVACY,
      el: 'v-contact',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
};
</script>
